import { getBackendUrl } from '../utils/apiConfig';

const API_MEDIA_RE = /\/api\/media\/[a-f0-9-]+/i;

const parseApiError = async (response) => {
  try {
    const err = await response.json();
    if (typeof err.detail === 'string') return err.detail;
    if (Array.isArray(err.detail)) return err.detail.map((e) => e.msg).join(', ');
    return null;
  } catch {
    return null;
  }
};

/** Chemin à enregistrer en base : /api/media/{uuid} ou URL externe (Unsplash…). */
export const mediaStoragePath = (pathOrUrl) => {
  if (!pathOrUrl) return '';
  const match = String(pathOrUrl).match(API_MEDIA_RE);
  if (match) return match[0];
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;
  return pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
};

/** URL affichable dans <img src> — réécrit les domaines internes Emergent. */
export const mediaUrl = (pathOrUrl) => {
  if (!pathOrUrl) return '';
  if (pathOrUrl.startsWith('data:')) return pathOrUrl;

  const match = String(pathOrUrl).match(API_MEDIA_RE);
  if (match) {
    const base = getBackendUrl().replace(/\/$/, '');
    return `${base}${match[0]}`;
  }

  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
    return pathOrUrl;
  }

  const base = getBackendUrl().replace(/\/$/, '');
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${base}${path}`;
};

export const mediaAPI = {
  uploadImage: async (file) => {
    const token = localStorage.getItem('auth_token');
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${getBackendUrl()}/api/media/upload`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });

    if (!response.ok) {
      const detail = await parseApiError(response);
      if (response.status === 401) {
        throw new Error('Session expirée — reconnectez-vous en admin.');
      }
      if (response.status === 403) {
        throw new Error('Accès refusé — compte admin requis.');
      }
      throw new Error(detail || "Impossible d'envoyer l'image (vérifiez que le backend est à jour).");
    }

    const data = await response.json();
    const storagePath = mediaStoragePath(data.path || data.url);
    return {
      ...data,
      url: storagePath,
      absoluteUrl: mediaUrl(storagePath),
    };
  },
};

export default mediaAPI;
